import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { getRegistrationSubtotal } from "@qgiv/p2p-registration";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import {
    selectCmsControlByIdByPage,
    selectThemeSettings,
} from "../../../redux/slices/cmsSettingsSlice";
import { ThemeType } from "../../../redux/constants";
import ReceiptDetailsParticipants from "./ReceiptDetailsParticipants";

const ConnectedReceiptDetailsParticipants = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const receipt = useSelector(selectReceipt);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const p2pClassificationLabel = p2pSettings.classificationLabel
        ? p2pSettings.classificationLabel
        : "";
    const {
        transaction: { registrations = [] },
    } = receipt;
    const subtotal = getRegistrationSubtotal(receipt);

    const originalTotal = registrations.reduce(
        (_originalTotal, registration) => {
            const { originalCategoryFee = 0.0 } = registration;
            return _originalTotal + originalCategoryFee;
        },
        0.0,
    );

    const showSubtotal =
        originalTotal > subtotal ||
        (originalTotal === subtotal && subtotal !== 0 && originalTotal !== 0);

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { classificationLabel },
    } = control;

    const classificationName =
        registrations.length > 0 && registrations[0].classificationName
            ? registrations[0].classificationName
            : "";

    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );

    const {
        p2pRegistration: { regSubsectionHeading = "Registration" },
        p2pGeneral: { subtotalLabel = "Subtotal" },
    } = themeSettings;

    const receiptDetailsParticipantsProps = {
        classificationLabel: classificationName
            ? classificationLabel
                  .replace(
                      "%ClassificationLabel%",
                      p2pClassificationLabel || "Classification",
                  )
                  .replace("%RegistrantClassification%", classificationName)
            : "",
        registrations,
        subtotal,
        originalTotal,
        controlId,
        participantsLabel: regSubsectionHeading,
        registrationSubtotalLabel: subtotalLabel,
        showSubtotal,
    };

    return <ReceiptDetailsParticipants {...receiptDetailsParticipantsProps} />;
};

ConnectedReceiptDetailsParticipants.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptDetailsParticipants;
